import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../AuthContext';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const AuthCallback = () => {
  const hasProcessed = useRef(false);
  const navigate = useNavigate();
  const { setUser } = useAuth();

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) { navigate('/login', { replace: true }); return; }

    const sessionId = match[1];
    window.history.replaceState(null, '', window.location.pathname);

    (async () => {
      try {
        const res = await axios.post(`${API}/auth/session`, { session_id: sessionId });
        if (res.data && res.data.session_token) {
          // Save auth data with token to localStorage
          setUser(res.data);
          navigate('/app', { replace: true });
        } else {
          throw new Error('No session token');
        }
      } catch (e) {
        console.error('Auth error:', e);
        navigate('/login', { replace: true });
      }
    })();
  }, [navigate, setUser]);

  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', background: '#f5f7fa' }}>
      <div style={{ textAlign: 'center' }}>
        <div className="spin" style={{ width: 32, height: 32, border: '3px solid #e5e7eb', borderTopColor: '#3b82f6', borderRadius: '50%', margin: '0 auto 16px' }} />
        <p style={{ color: '#6b7280' }}>Accesso in corso...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
